import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
const TheOutside = () => import('@/containers/TheOutside')

// Pages
const Home = () => import('@/pages/private/Home')
const Order = () => import('@/pages/private/Order')
const Orders = () => import('@/pages/private/Orders')
const Details = () => import('@/pages/private/Details')
const About = () => import('@/pages/private/About')
const Settings = () => import('@/pages/private/Settings')
const Notifications = () => import('@/pages/private/Notifications')

// Logout
const Logout = () => import('@/pages/private/Logout')

const Signin = () => import('@/pages/public/Signin')
const Reset = () => import('@/pages/public/Reset')
// const ForgotPassword = () => import('@/pages/public/Forgotpassword')
// const ResetPassword = () => import('@/pages/public/Resetpassword')
const LockAccount = () => import('@/pages/public/LockAccount')

Vue.use(Router)

export const router = new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/home',
            name: 'App',
            component: TheContainer,
            children: [
                {
                    path: '/home',
                    name: 'Home',
                    component: Home
                },
                {
                    path: '/order',
                    name: 'Order',
                    component: Order
                },
                                {
                    path: '/orders',
                    name: 'Orders',
                    component: Orders
                },
                {
                    path: '/details',
                    name: 'Details',
                    component: Details
                },
                {
                    path: '/settings',
                    name: 'Settings',
                    component: Settings,
                },
                // {
                //     path: '/notifications',
                //     name: 'Nofifications',
                //     component: Notifications,
                // },
                // {
                //     path: '/about',
                //     name: 'About',
                //     component: About
                // },
                {
                    path: '/logout',
                    name: 'Logout',
                    component: Logout
                },
            ]
        },
        {
            path: '/',
            component: TheOutside,
            name: "Public",
            children: [
                {
                    path: "/signin",
                    name: "Sign in",
                    component: Signin
                },
                // {
                //     path: "/forgotpassword",
                //     name: "Forgot Password",
                //     component: ForgotPassword
                // },
                // {
                //     path: "/resetpassword",
                //     name: "Reset Password",
                //     component: ResetPassword
                // },
                {
                    path: "/reset",
                    name: "Reset",
                    component: Reset
                },
                {
                    path: '/lock-account',
                    name: 'Lock Account',
                    component: LockAccount,
                },

            ]
        },

    ]
})

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/signin', '/reset'];
    const authRequired = !publicPages.includes(to.path);

    if (authRequired) {
        if (!store.getters.user) {
            return next('/signin');
        } else {
            next();
        }
    } else {
        next();
    }

})
